/* eslint-disable */

const data = [
  { id: "Spot", es: "🛒  Spot", ch: "🛒  仅购买单独体验" },
  { es: "Tipo de cliente", ch:  "客户分类" },
  { es: "Urgente", ch: "紧急" },
  { es: "Cliente spot", ch: "仅购买单独体验" },
  { es: "Cliente Spot", ch: "仅购买单独体验" },

  { es: "Plan de viaje", ch: "签证行程单" },
  { es: 'Este es el plan de viaje para las oficinas de visado.', ch: "此表格只需转发于签证代办处，办理签证。" },
  { es: 'Recuerda revisar el documento antes de enviarlo.', ch: "下载并转发时请检查路线是否正确。" },
  { es: "Descargar ruta para visado (plan de viaje)", ch: "下载签证行程单"},

  { es: "Falta título", ch: "缺少标题" },

  { es: "Lunes", ch: "周一" },
  { es: "Martes", ch: "周二" },
  { es: "Miércoles", ch: "周三" },
  { es: "Jueves", ch: "周四" },
  { es: "Viernes", ch: "周五" },
  { es: "Sábado", ch: "周六" },
  { es: "Domingo", ch: "周日" },

  { es: "Crear gasto", ch: "创建新费用" },
  { es: "Crear", ch: "新建" },
  { es: "Crear ciudad", ch: "增添新城市" },
  { es: "grupo", ch: "团体" },
  { es: "Otros gastos", ch: "其他费用" },
  { es: "Crear nuevo gasto", ch: "增添新费用" },
  { es: "% Gastos de Gestión", ch: "% 手续费" },
  { es: "Redondear a", ch: "四舍五入到" },
  { es: "Sólo redondear hacia arriba", ch: "四舍五入价格略微上涨" },
  { es: "Sin Gº de gestión", ch: "线路不收取手续费" },
  { es: "Actividad sin nombre", ch: "体验活动无名称" },
  { es: "Texto de la tarea", ch: "任务名" },
  { es: "Servicios", ch: "Servicios" },
  { es: "Día vacío", ch: "该天未安排体验活动" },
  { es: "Generar", ch: "生成" },
  { es: "Contenido del documento", ch: "文件内容" },
  { id: "connection_stablished", es: "Conexión establecida correctamente", ch: "成功连接网络" },
  { id: "connection_restablished", es: "Conexión reestablecida", ch: "重新连接网络" },
  { id: "connection_lost", es: "Se ha perdido la conexión", ch: "丢失网络连接" },
  { es: "Error desconocido", ch: "未知错误" },
  { id: "reset_pwd_ok", es: "Hecho; recibirás un enlace en tu correo para resetear tu contraseña", ch: "完成请求; 你的注册邮箱将会收到重新设置密码的连接" },
  { es: "Volver al login", ch: "重新登陆" },
  { es: "Sin asignar", ch: "未指定客服人员" },
  { es: "sin fecha", ch: "无日期" },
  { es: "Yo", ch: "本人" },
  { es: "Sin redondeo", ch: "无需四舍五入" },
  { es: "Unidades", ch: "个位" },
  { es: "Decenas", ch: "十位" },
  { es: "Centenas", ch: "百位" },

  { es: "Contraseña", ch: "密码" },
  { es: "Entrar", ch: "进入" },
  { es: "Olvidé mi contraseña", ch: "忘记密码" },
  { es: "Notas vacías", ch: "备注为空" },
  { es: "Previsualizar", ch: "预览" },
  { es: "Añadir (elegir posición)", ch: "增加(选择位置)" },
  { es: "Añadir al final de la ruta", ch: "增加至线路末尾" },
  { es: "Reemplazar todo", ch: "全部替换" },
  { es: "Nombre de la plantilla", ch: "模版名称" },
  { id: "chinese_name", es: "🇨🇳 Nombre en chino", ch: "🇨🇳 中文名" },

  { id: "Elige qué plan usar", es: "Elige qué plan iniciar", ch: "选择使用以下一类计划" },

  { es: "Fondo para documento 1 (para Propuesta)", ch: "城市背景图片(出现在最终PDF线路中)" },
  { es: "PDF descripción (para Propuesta)", ch: "城市PDF介绍" },
  { es: "Imagen de fondo", ch: "Imagen de fondo" },
  { es: "Guardar", ch: "保存" },
  { es: "Página(s) para guión #1", ch: "体验活动PDF" },

  { es: "repetición", id: "aitem_rep_1", ch: "复制" },
  { es: "", id: "aitem_rep_2", ch: "次" },
  { es: "", id: "aitem_night_1", ch: "第" },
  { es: "ª noche", id: "aitem_night_2", ch: "晚" },
  { es: "Página(s) para guión #1", ch: "体验活动PDF" },

  { id: "plan1_task1", es: "Llamar al cliente para explicarle la ruta"         , ch: "电话或微信联系客户询问线路进展" },
  { id: "plan1_task2", es: "Llamada para ver qué dudas tiene"                  , ch: "电话或微信联系客户帮助解答疑惑" },
  { id: "plan1_task3", es: "Hablarle sobre la ruta"                            , ch: "联系客户谈论线路" },
  { id: "plan1_task4", es: "Charla sobre la ruta, con recomendaciones"         , ch: "联系客户谈论线路，旅游提示" },
  { id: "plan1_task5", es: "Ya deberíamos intentar cerrar y enviar el contrato", ch: "尽量和客户确定线路并发送合同" },
  { id: "plan1_task6", es: "Avisar al Cliente"                                 , ch: "提醒客户是否继续线路" },
  { id: "plan1_task7", es: "Avisar al Cliente"                                 , ch: "提醒客户是否继续线路" },
  { id: "plan1_task8", es: "Avisar al Cliente"                                 , ch: "提醒客户是否继续线路" },
  { es: "Plan 1", ch: "计划1" },
  { es: "Cómo convencer a un cliente de que acepte nuestra propuesta", ch: "让客户尽快接受线路" },
  { es: "Iniciar este plan", ch: "开启计划" },
  { id: "warning_plan_no_assign", 
    es: "El cliente no está asignado a nadie, así que las tareas se te van a asociar a ti",
    ch: "客户没有指定其他客服人员，计划将会发送给你" },

  { es: "¿Activar plan en este viaje?", ch: "开启计划吗?" },
  { id: "plan_trigger_question_1", es: "Para el viaje de ", ch: "需要给" },
  { id: "plan_trigger_question_2", es: ", ¿quieres activar este plan?", ch: "开启计划吗?" },
  { es: "¡El plan ya ha sido iniciado para este cliente!", ch: "该客户计划已开启" },

  { es: '(Puedes iniciarlo a mano en "Tareas > Iniciar plan")', ch: "你能进入 计划>开启计划 手动开启计划" },
  { es: "Sí, iniciar plan", ch: "是的，开启计划" },
  { es: "No, no iniciar por ahora", ch: "不，暂时不开启计划" },

  {
    id: "num_tareas",
    es: "tareas",
    ch: "个任务"
  },

  /**** *****/

  { es: "Añadir aquí", ch: "在此处添加" },
  { es: "Nombre de la plantilla", ch: "模版名称" },

  { 
    id: "replace_all_with_block",
    es: "Vas a reemplazar toda la ruta (incluyendo gastos y transporte) por esta plantilla; ¿estás seguro?",
    ch: "你将要替换整条线路，包括模版线路中的其他费用，交通等所有信息。确定要替换吗?"
  },

  { id: "desglose_section_1", es: "Actividades del día", ch: "第" },
  { id: "desglose_section_2", es: "", ch: "天的体验活动" },

  { es: "Item", ch: "项目" },
  { es: "Aviso", ch: "通知" },
  { es: "Comp.", ch: "已购买" },
  { es: "Notas", ch: "注释" },
  { id: "notas_spanish", es: "🇪🇸 Notas", ch: "🇪🇸 注释" },
  { es: "Generar CSV", ch: "生成CSV文件" },
  { es: "Generar XLSX", ch: "生成EXCEL文件" },
  { es: "Desglose de gastos", ch: "费用清单" },
  { es: "Contrato", ch: "线路详细列表" },
  { es: "Descargar contrato", ch: "下载线路详细列表" },
  { es: "Otros gastos", ch: "其他费用" },
  { es: "Viaje a", ch: "前往" },

  { 
    id: "contrato_warn_1",
    es: "Este documento no se genera 100% completo; por favor, revísalo manualmente.",
    ch: "Este documento no se genera 100% completo; por favor, revísalo manualmente."
  },
  { 
    id: "contrato_warn_1.5",
    es: "Sobre todo, revisa los precios indicados!",
    ch: "Sobre todo, revisa los precios indicados!",
  },
  { 
    id: "contrato_warn_2",
    es: "Algunos nombres en la columna 行程项目 no caben; cambia el ancho, o borra la columna de al lado (aunque esté vacía, a veces funciona).",
    ch: "注意需要手动调整表格中部分列的宽度并删除右侧空的列表"
  }, { 
    id: "contrato_warn_3",
    es: "La altura de las filas es muy pequeña; probablemente quieras cambiarla a mano.",
    ch: "请手动调整每行的高度"
  }, { 
    id: "contrato_warn_4",
    es: "La columna sobre comidas (餐饮) hay que rellenarla a mano.",
    ch: "餐饮列需要手动调整是否包含午餐或晚餐"
  }, { 
    id: "contrato_warn_5",
    es: "El campo de ciudad de origen (国内出行城市) también hay que ponerlo a mano.",
    ch: "国内出行城市需要手动填写"
  },
  { es: "Descargar XLSX", ch: "下载EXCEL文档" },
  { es: "Configuración del PDF", ch: "PDF线路编辑" },
  { id: "trip_to_x", es: "Viaje a", ch: "前往" },

  { id: "Spain"       ,  es: "España" ,  ch: "西班牙" } ,
  { id: "Andorra"    ,  es: "Andorra" ,  ch: "安道爾" } ,
  { id: "Germany"     ,  es: "Alemania" ,  ch: "德國" } ,
  { id: "France"      ,  es: "Francia" ,  ch: "法國" } ,
  { id: "Italy"       ,  es: "Italia" ,  ch: "意大利" } ,
  { id: "Portugal"    ,  es: "Portugal" ,  ch: "葡萄牙" } ,
  { id: "Argentina"   ,  es: "Argentina" ,  ch: "阿根廷" } ,
  { id: "Czechia"     ,  es: "República Checa" ,  ch: "捷克的" } ,
  { id: "Greece"      ,  es: "Grecia" ,  ch: "希臘" } ,
  { id: "Switzerland" ,  es: "Suiza" ,  ch: "瑞士" } ,
  { id: "Belgium", es: "Bélgica", ch: "比利時" },
  { id: "United Kingdom", es: "Reino Unido", ch: "聯合王國" },

{ id: "Morocco"    ,  es: "Marruecos",   ch: "摩洛哥" },
{ id: "Netherlands",  es: "Países Bajos",   ch: "荷蘭" },
{ id: "Austria"    ,  es: "Austria",   ch: "奧地利" },
{ id: "Finland"    ,  es: "Finlandia",   ch: "芬蘭" },
{ id: "Sweden"     ,  es: "Suecia",   ch: "瑞典" },
{ id: "Norway"     ,  es: "Noruega",   ch: "挪威" },
{ id: "Denmark"    ,  es: "Dinamarca",   ch: "丹麥" },
{ id: "Scotland"   ,  es: "Escocia",   ch: "蘇格蘭" },
{ id: "Ireland"    ,  es: "Irlanda",   ch: "愛爾蘭" },
{ id: "Egypt"      ,  es: "Egipto",   ch: "埃及" },
{ id: "Israel"     ,  es: "Israel",   ch: "以色列" },
{ id: "Poland"     ,  es: "Polonia",   ch: "波蘭" },

  { id: "notas_contrato", es: "🇨🇳 Notas contrato"                , ch: "🇨🇳 关于合同说明" }   ,

  { es: "Home"                          , ch: "首页" }           ,
  { es: "Administración"                , ch: "线路管理" }       ,
  { es: "Operación"                     , ch: "客户管理" }       ,
  { es: "Salir"                         , ch: "离开" }           ,
  { es: "Tus negociaciones en progreso" , ch: "进展中的线路" }   ,
  { es: "(aún no han pagado fianza)"    , ch: "(还未支付定金)" } ,
  { es: "Tus tareas pendientes"         , ch: "需完成的任务" }   ,
  { id: "editButton"                    , es: "Edit"             , ch: "编辑" } ,
  { es: "Desconocido"                   , ch: "陌生人" }         ,
  { es: "días"                          , ch: "天" }             ,
  { es: "Añadir campo"                  , ch: "创建新内容" }     ,
  { es: "Comentario breve"              , ch: "简短说明" }       ,
  { es: "(sobre el estado del cliente)" , ch: "(关于客户状态)" } ,
  { es: "Estado"                        , ch: "状态" }           ,
  { es: "Nuevos"                        , ch: "新客户" }         ,
  { es: "Abrobados"                     , ch: "确认订单" }       ,
  { es: "Cerrados"                      , ch: "旅行圆满完成" }   ,
  { es: "Perdidos"                      , ch: "已丢失客户" }     ,
  { es: "Estado"                        , ch: "客户状态" }       ,
  { es: "Apodo"                         , ch: "客户昵称" }       ,
  { es: "Nombre real"                   , ch: "客户真实姓名" }   ,
  { es: "Grupo"                         , ch: "人数" }           ,
  { es: "Encargado"                     , ch: "客服人员" }       ,
  { es: "Fechas"                        , ch: "客户旅行日期" }   ,
  { es: "Creación"                      , ch: "线路生成日期" }   ,
  { es: "Comentario"                    , ch: "备注事项" }       ,
  { es: "Actualizar"                    , ch: "刷新" }           ,
  { es: "Crear viaje"                   , ch: "生成线路" }       ,
  { es: "Descargar reporte"             , ch: "下载报告" }       ,
  { es: "Lista de viajes"               , ch: "返回上级" }       ,
  { es: "Datos"                         , ch: "信息" }           ,
  { es: "Apodo"                         , ch: "昵称" }           ,
  { es: "WeChat ID"                     , ch: "微信ID" }         ,
  { es: "Origen"                        , ch: "来源地" }         ,
  { es: "Apodo (pinyin)"               , ch: "客户昵称 (拼音)" }    ,
  { es: "Email"                         , ch: "Email" }          ,
  { es: "Número de adultos"             , ch: "成人数" }         ,

  { es: "Nuevo cliente"                 , ch: "新客户" }         ,
  { es: "Propuesta enviada"             , ch: "已发送线路" }     ,
  { es: "Contrato enviado"              , ch: "已发送合同" }     ,
  { es: "Cerrado"                       , ch: "已结束旅行" }     ,
  { es: "Perdido"                       , ch: "已丢失客户" }     ,
  { es: "Fianza pagada"                 , ch: "定金已收取" }     ,
  { es: "Pago parcial"                  , ch: "第二笔定金" }     ,
  { es: "Pago completo"                 , ch: "全款已收取" }     ,
  { es: "Aprobado sin fianza"           , ch: "已确定合同（无需定金）" }     ,

  { id: "aprobado_sin_fianza", es: "Aprobado sin Fianza"           , ch: "已确定合同（无需定金）" }     ,

  { id: "sh_Nuevo cliente"      , es: "Nuevo" , ch: "新客户" }     ,
  { id: "sh_Propuesta enviada"  , es: "Propuesta"     , ch: "已发送线路" } ,
  { id: "sh_Contrato enviado"   , es: "Contrato"      , ch: "已发送合同" } ,
  { id: "sh_Cerrado"            , es: "Cerrado"       , ch: "已结束旅行" } ,
  { id: "sh_Perdido"            , es: "Perdido"       , ch: "已丢失客户" } ,
  { id: "sh_Fianza pagada"      , es: "Fianza"        , ch: "定金已收取" } ,
  { id: "sh_Pago parcial"       , es: "Pago parte"    , ch: "第二笔定金" } ,
  { id: "sh_Pago completo"      , es: "Pago todo"     , ch: "全款已收取" } ,
  { id: "sh_aprobado_sin_fianza", es: "Aprobado"      , ch: "已确定合同" } ,

  {
    id: "transporte_a_1",
    es: "Transporte a ",
    ch: "前往"
  },
  {
    id: "transporte_a_2",
    es: "",
    ch: "交通方式"
  },
  {
    id: "viaje_a_1",
    es: "Transporte a ",
    ch: "前往"
  },
  {
    id: "viaje_a_2",
    es: "",
    ch: "交通方式"
  },

  { id: "avion_a",    es: "Avión a ",   ch: "乘飞机前往"    },
  { id: "bus_a",      es: "Bus a ",     ch: "乘巴士前往"    },
  { id: "tren_a",     es: "Tren a ",    ch: "乘火车前往"    },
  { id: "coche_a",    es: "Coche a ",   ch: "开车前往"      },

  {
    id: "dia_1",
    es: "Día ",
    ch: "第"
  },
  {
    id: "dia_2",
    es: "",
    ch: "天"
  },
  {
    id: "btn_pdf_options",
    es: "Opciones PDF",
    ch: "PDF编辑"
  },

  {
    es: "Número de...",
    ch: "人数"
  },
  { 
    es: "Adultos",
    ch: "成人数"
  },
  { 
    es: "Ruta sin nombre",
    ch: "线路未命名"
  },
  { 
    es: "Nombre de la ruta",
    ch: "线路名称"
  },
  {
    es: "Itinerario",
    ch: "线路"
  },
  {
    es: "Guardar todo como plantilla",
    ch: "保存为模版线"
  },
  {
    es: "Guardar selección como plantilla",
    ch: "将选中区域保存为模版"
  },
  {
    es: "Guardar plantilla",
    ch: "保存模板"
  },
  {
    es: "0 tareas",
    ch: "0个任务"
  },
  {
    es: "Selección",
    ch: "勾"
  },
  { 
    es: "Medio",
    ch: "选择交通方式"
  },
  { 
    es: "Notas",
    ch: "备注"
  },
  { 
    es: "General",
    ch: "常规"
  },
  { 
    es: "Horario",
    ch: "班次时间"
  },
  {
    es: "Reset",
    ch: "重新设置"
  },
  {
    es: "Añadir",
    ch: "增加"
  },
  {
    es: "Añadiendo",
    ch: "增加"
  },
  {
    es: "Añadir nota",
    ch: "添加评论"
  },
  {
    es: "Nombre del gasto",
    ch: "费用名称"
  },
  {
    es: "Cancelar",
    ch: "取消"
  },
  {
    es: "Aceptar",
    ch: "确认"
  },
  {
    es: "Incluir precio",
    ch: "包含报价"
  },
  {
    es: "Columnas por página",
    ch: "最多列数"
  },
  {
    es: "Tamaño columnas",
    ch: "每列行数"
  },
  {
    es: "Tamaño fuente",
    ch: "字体大小"
  },
  {
    es: "Refrescar preview",
    ch: "刷新并预览"
  },
  {
    es: "Ver grande",
    ch: "放大"
  },
  {
    es: "Cerrar",
    ch: "关闭"
  },
  {
    es: "Eliminar",
    ch: "删除"
  },
  {
    es: "Clonar",
    ch: "复制"
  },
  {
    es: "Seleccionar",
    ch: "定为最终线路"
  },
  {
    es: "Sólo gastos en la ciudad...",
    ch: "根据城市筛选"
  },
  {
    es: "Crear nuevo gasto  ",
    ch: "增加新费用"
  },
  {
    es: "Editar",
    ch: "编辑"
  },
  {
    es: "Nueva planilla",
    ch: "创建模版"
  },
  {
    es: "Aprobados",
    ch: "已确认线路"
  },
  {
    es: "Editar precio",
    ch: "编辑价格"
  },
  {
    es: "Introduce el nombre de la nueva plantilla",
    ch: "命名新模版"
  },
  {
    es: "Introduce el nombre de la nueva plantilla",
    ch: "将线路保存为模版命名新模版"
  },
  {
    es: "en español",
    ch: "西班牙语"
  },
  {
    es: "en chino",
    ch: "中文"
  },
  {
    es: "Al guardar una selección no se incluyen los gastos generales",
    ch: "保存小部分线路(不包含其他费用)"
  },

  {
    id: "",
    es: "",
    ch: ""
  },
  {
    id: "expense_type_normal",
    es: "Normal",
    ch: "常规"
  },
  {
    id: "expense_type_hotel",
    es: "Hotel",
    ch: "酒店"
  },

  { 
    es: "Lista de viajes solicitados",
    ch: "客户列表"
  },
  { 
    es: "Quizá tengas que refrescar la página para que el cambio de lenguaje se aplique completamente",
    ch: "您可能需要刷新此页面才能让语言完全切换成中文版"
  },
  {
    id: "kids",
    es: "Niños",
    ch: "儿童数"
  },
  {
    es: "Fechas (A/M/D)",
    ch: "旅行日期(年/月/日)"
  },
  {
    es: "Inicio",
    ch: "开始日期"
  },
  {
    es: "Fin",
    ch: "结束日期"
  },
  {
    id: "descripcion_retorno",
    es: "🇨🇳 Descripción retorno",
    ch: "🇨🇳 客户线路描述"
  },
  {
    es: "(aparece en la propuesta)",
    ch: "客户线路描述"
  },
  {
    es: "Ruta",
    ch: "线路"
  },
  {
    es: "Desglose",
    ch: "报价分类汇总"
  },
  {
    es: "Contrato",
    ch: "线路报价表"
  },
  {
    es: "Ticket",
    ch: "查看线路"
  },
  {
    es: "Precio",
    ch: "报价"
  },
  {
    es: "Propuesta",
    ch: "下载线路"
  },
  {
    es: "Gastos generales",
    ch: "其他费用"
  },
  {
    es: "Más info",
    ch: "查看详情"
  },
  {
    es: "Guardar todo como plantilla",
    ch: "保存为模版"
  },
  {
    es: "Selección",
    ch: "选择项目"
  },
  {
    es: "Nuevo día",
    ch: "增加天数"
  },
  {
    es: "Añadir día",
    ch: "增加天数"
  },
  {
    es: "Plantilla",
    ch: "模版"
  },
  {
    es: "Actividades",
    ch: "单个体验"
  },
  {
    es: "Gastos",
    ch: "费用"
  },
  {
    es: "Gastos y hoteles",
    ch: "费用和酒店"
  },
  {
    es: "Tareas y comentarios",
    ch: "任务及备注"
  },
  {
    es: "Comentarios",
    ch: "备注"
  },
  {
    es: "No hay comentarios",
    ch: "无备注"
  },
  {
    es: "Añadir comentario",
    ch: "创建新备注"
  },
  {
    es: "Tareas",
    ch: "任务"
  },
  {
    es: "Tareas pasadas",
    ch: "昨天的任务"
  },
  {
    es: "0 tareas",
    ch: "0项任务"
  },
  {
    es: "Tareas de hoy",
    ch: "今天的任务"
  },
  {
    es: "Tareas de mañana",
    ch: "明天的任务"
  },
  {
    es: "Tareas posteriores",
    ch: "后续任务"
  },
  {
    es: "Añadir tarea",
    ch: "创建新任务"
  },
  {
    es: "Iniciar plan",
    ch: "开启计划"
  },
  // Administración
  {
    es: "Plantilla",
    ch: "模版"
  },
  {
    es: "Plantilla de gasto",
    ch: "费用模版"
  },
  {
    es: "Plantillas",
    ch: "线路模版"
  },
  {
    es: "Plantillas de gasto",
    ch: "费用模版"
  },
  {
    es: "Actividades",
    ch: "体验活动"
  },
  {
    es: "Ciudades",
    ch: "城市"
  },
  {
    es: "Nueva plantilla",
    ch: "创建新模版"
  },
  {
    es: "Días",
    ch: "天数"
  },
  {
    es: "Nombre",
    ch: "命名"
  },
  {
    es: "Nota",
    ch: "备注"
  },
  {
    es: " la nota ",
    ch: "备注"
  },
  {
    es: "Creación",
    ch: "创建日期"
  },
  {
    es: "Inicio",
    ch: "创建日期"
  },
  {
    es: "Modificación",
    ch: "改动日期"
  },
  // Plantilla de gasto
  {
    es: "Ciudad",
    ch: "城市"
  },
  {
    es: "Tipo",
    ch: "种类"
  },
  {
    es: "Nombre",
    ch: "西语名称"
  },
  {
    id: "spanish_title",
    es: "🇪🇸 Nombre español",
    ch: "🇪🇸 西语名称"
  },
  {
    id: "spanish_name",
    es: "🇪🇸 Nombre español",
    ch: "🇪🇸 西语名称"
  },
  { 
    id: "Nombre español",
    es: "🇪🇸 Nombre español",
    ch: "🇪🇸 西语名称"
  },
  {
    id: "chinese_title",
    es: "🇨🇳 Nombre chino",
    ch: "🇨🇳 中文名称",
  },
  {
    id: "english_title",
    es: "🇬🇧 Nombre inglés",
    ch: "🇬🇧 英语名称",
  },
  {
    es: "Nuevo gasto",
    ch: "创建新费用"
  },
  {
    es: "Añadir gasto",
    ch: "创建新费用"
  },
  {
    es: "Gasto válido para cualquier ciudad",
    ch: "任何城市都适用"
  },
  {
    es: "País",
    ch: "国家"
  },
  {
    es: "Precio (para el cliente)",
    ch: "售价"
  },
  {
    es: "General (€)",
    ch: "总值"
  },
  {
    es: "Por persona",
    ch: "所有人"
  },
  {
    id: 'kidsDifferent',
    es: "Por adulto/niño",
    ch: "成人/儿童"
  },
  {
    id: 'perGroup',
    es: "Por grupo",
    ch: "群体"
  },
  {
    es: "Coste",
    ch: "成本"
  },
  {
    es: "Coste (para nosotros)",
    ch: "成本"
  },
  // Actividades
  {
    es: "Filtra por ciudad",
    ch: "按城市查询"
  },
  {
    es: "Nueva actividad",
    ch: "创建新体验"
  },
  {
    id: "Nombre (🇪🇸 )",
    es: "🇪🇸 Nombre español",
    ch: "🇪🇸 西语名称"
  },
  {
    id: "Título",
    es: "🇨🇳 Nombre chino",
    ch: "🇨🇳 中文名称",
  },
  {
    es: "Duración (h)",
    ch: "耗时(小时)"
  },
  {
    es: "Duración (horas)",
    ch: "耗时(小时)"
  },
  {
    es: "Descripción breve",
    ch: "简短说明"
  },
  {
    es: "Descripción completa",
    ch: "详细描述"
  },
  {
    es: "Notas",
    ch: "备注"
  },
  {
    es: "Ficheros",
    ch: "文件"
  },
  {
    es: "Seleccionar archivo",
    ch: "上传文件"
  },
  {
    es: "Ningún archivo seleccionado",
    ch: "未选择文件"
  },
  {
    es: "Intereses relevantes:",
    ch: "兴趣偏好"
  },
  {
    id: "pref_compras",
    es: "🛍 Compras",
    ch: "🛍 购物"
  },
  {
    id: "pref_cultura",
    es: "🖼 Cultura",
    ch: "🖼 文化"
  },
  {
    id: "pref_gastronomia",
    es: "🍔 Gastronomía",
    ch: "🍔 美食"
  },
  {
    id: "pref_pareja",
    es: "💘 Viaje en pareja",
    ch: "💘 浪漫"
  },
  {
    id: "pref_deportes",
    es: "⚽️ Fútbol / deportes",
    ch: "⚽️ 足球/体育"
  },
  // Ciudades
  {
    es: "Nueva ciudad",
    ch: "增加城市"
  },
  {
    es: "Añadir ciudad",
    ch: "增加城市"
  },
  {
    es: "Añadir gasto general",
    ch: "增加一般费用"
  },
  {
    es: "País",
    ch: "国家"
  },
  {
    es: "🇪🇸  Español",
    ch: "🇪🇸  西语名称"
  },
  {
    es: "Chino",
    ch: "中文名称"
  },
  {
    es: "Fondo",
    ch: "背景图"
  },
  {
    es: "PDF descripción",
    ch: "PDF城市介绍"
  },
  {
    es: "Editar ciudad",
    ch: "编辑城市"
  },
  {
    es: "Subir ficheros",
    ch: "上传文件"
  },
  {
    es: "Cambiar",
    ch: "替换"
  },

  {
    id: "refreshToChangeLang",
    es: "Quizá tengas que refrescar la página para que el cambio de lenguaje se aplique completamente",
    ch: "您可能需要刷新页面用于该语言的变化是全面实施"
  },

  { es: "Contenido de la plantilla", ch: "模版内容" },
  { es: "Sin notas; click para editar", ch: "无备注; 点击后编辑" },
  { es: "Volver a la lista", ch: "返回上级" },
  { es: "normal", ch: "常规" },
  { es: "Normal", ch: "常规" },
  { es: "hotel", ch: "酒店" },
  { es: "Hotel", ch: "酒店" },
  { es: "Intereses relevantes", ch: "相关信息" },
  { es: "Ficheros", ch: "文件" },
  { es: "Quitar fichero", ch: "删除文件" },
  { es: "Descargar", ch: "下载文件" },
  { es: "Subiendo...", ch: "上传文件" },
  { es: "Tareas atrasadas", ch: "被拖延任务" },
  { es: "Otras tareas", ch: "其他任务" },
  { es: "Medio	交通方式" },
  { es: "(códigos, duración...)", ch: "(订单信息，行驶时间)" },
  { es: "Seleccionar medio de transporte", ch: "选择交通方式" },
  { es: "No seleccionado", ch: "不选择交通方式 " },

  { id: "error_route_length"     ,  es: "El viaje es de $$ días pero la ruta seleccionada tiene $$ " ,  ch: "行程计划安排了$$天但是实际安排了$$天" },
  { id: "error_city_title"       ,  es: "La ciudad $$ no tiene traduccion al chino"             ,  ch: "城市$$没有中文翻译" },
  { id: "error_missing_titles"   ,  es: "Estos gastos o actividades no tienen título en chino:" ,  ch: "以下费用和体验没有中文标题" },
  { es: "Errores"                ,                                                                 ch: "错误" },
  { es: "Error"                  ,                                                                 ch: "错误" },
  { id: "error_missing_files"    ,  es: "Error generando el pdf. Faltan ficheros:"             ,  ch: "生成PDF线路出现错误。 缺少文件:" },
  { id: "error_expired_login"    ,  es: "Login caducado; por favor, entra de nuevo."            ,  ch: "登陆过期;请重新登陆" },
  { id: "error_pdf_generation"   ,  es: "Error generando el PDF:"                               ,  ch: "生成PDF线路出现错误" },
  { id: "docpagesmodal_msg", es: "Selecciona qué ficheros incluir en el documento. Esto no afecta a la ruta personalizada para el cliente, sólo qué le vamos a enseñar en este momento.", ch: "选择需要进入PDF的文件。如果想要隐藏某个体验活动只需取消勾选此体验活动即可。" },
  { id: "error_missing_title_1", es: "La actividad $$ no tiene título", ch: "体验活动$$没有标题" },
  { id: "error_missing_title_2",     es: "$$ no tiene título", ch: "费用$$没有标题" },
  { id: "btn_status_ps", es: 'Marcar viaje como "📬 Propuesta enviada"', ch: '将新创建线路归类到¨线路已发送¨' },


  { es: "Generando documento...", ch: "正在生成线路" },
  { es: "Falta la fecha inicial", ch: "请选择开始日期" },
  { es: "Falta la fecha final", ch: "请选择结束日期" },
  { es: "Generar con errores", ch: "出现错误(任然生成线路)" },
  { es: "Portada", ch: "封面" },
  { es: "Quiénes somos", ch: "服务介绍" },
  { es: "Presupuesto", ch: "报价" },
  { es: "Contraportada", ch: "尾页" },
  { es: "Vuelta", ch: "返回" },
  { id: "page_city", es: "Presentación de $$", ch: "$$的PDF介绍" },
  { es: "sin fichero", ch: "没有文件" },

  { es: "Precio a mano", ch: "手动修改报价" },
  { es: "Precio automático", ch: "系统报价" },
  { es: "Precio en yuanes", ch: "人民币价格" },
  { es: "Precio en euros", ch: "欧元价" },
  { es: "Precio calculado sin %", ch: "成本价" },
  { es: "Configurar precio", ch: "调整报价" },

  { id: "price_with_pctg", es: "Precio calculado con $$%", ch: "包含$$手续费价格" },

  { id: "subtitle_admin", es: "Crear y administrar rutas y actividades", ch: "线路管理(生成管理线路及体验活动模版)" },
  { id: "subtitle_oper", es: "Leads e interacciones con los usuarios", ch: "客户管理(新老客户线路管理)" },
  { id: "home_your_clients", es: "Tus negociaciones en progreso (aún no han pagado fianza)", ch: "您正在管理的客户(还未支付定金)" },
  { id: "empty_md_field", es: "Click para editar", ch: "点击进行编辑" },
  { id: "filter_blocks", es: "Sólo plantillas con la ciudad...", ch: "按照城市选择模版线路" },

  { id: "delete_trip", es: 'Se va a eliminar el viaje de "$$", ¿estás seguro?', ch: "确定要删除$$的行程吗？" },
  { id: "delete_activity", es: '¿Seguro que desea borrar la actividad "$$"?', ch: "确定要删除$$这项体验活动吗？" },
  { id: "delete_expense", es: '¿Seguro que desea borrar la plantilla de gasto "$$"?', ch: "确定要删除$$这项费用模版吗？" },
  { id: "delete_block", es: '¿Seguro que desea borrar la plantilla "$$"?', ch: "确定要删除$$这项模版吗？" },
  { id: "delete_tag", es: '¿Seguro que desea borrar la etiqueta "$$"?', ch: "您确定要删除$$标记吗？"},
  { id: "no_encargado", es: "Asiga un encargado primero", ch: "请指定一位客服人员" },

  { id: "method_tripmaker", es: 'Tripmaker (AliPay)', ch: "Tripmaker (AliPay)" },
  { id: "method_bank", es: 'Banco (Surcursal)', ch: "银行转账" },
  { id: "method_wechat", es: 'WeChat', ch: "微信转账" },
  { id: "method_online", es: 'Banca Online', ch: "网络银行转账" },
  { id: "method_tpv", es: 'Tpv', ch: "刷卡" },
  { id: "method_cash", es: 'Efectivo', ch: "现金" },
  { id: "method_other", es: 'Otros', ch: "其他" },
  { es: "Editar pago", ch: "修改付款方式"},
  { es: 'Fecha de transferencia', ch: "转账日期" },
  { id: "receivedDate", es: 'Fecha de pago recibido', ch: "到账日期" },
  { id: "isReceived", es: 'Pago recibido', ch: "已到账" },
  { es: "Editar pago", ch: "修改付款方式"},
  { es: 'Método de pago', ch: "支付方法" },
  { es: 'Método de pago*', ch: "支付方法*" },
  { es: 'Euros*', ch: "欧元*" },
  { es: 'Yuanes', ch: "人民币" },
  { id: "isYuanEdited", es: 'Yuanes editados', ch: "编辑袁" },
  { id: "isEurEdited", es: 'Euros editados', ch: "编辑欧元" },
  { id: "receivedEur", es: 'Recibido (€)', ch: "到账(€)" },
  { es: 'Recibido', ch: "到账" },
  { es: 'Nuevo pago', ch: "新的款项" },
  { es: 'Total pagado', ch: "总付款" },
  { es: 'Coste presupuestado', ch: "路线总报价" },
  { es: 'Falta por pagar', ch: "未付款项" },
  { es: "Otros", ch: "其他" },
  { es: "Pagado", ch: "已付款项" },
  { es: "Total", ch: "所有" },
  { es: "Gº de Gestión (0 a 1)", ch: "手续费" },

  { id: "sh_clientClass_unknown", es: "Desconocido", ch: "无特定种类" },
  { id: "sh_clientClass_agency", es: "Agencia", ch: "旅行社" },
  { id: "sh_clientClass_curious", es: "Curioseando", ch: "出于兴趣关注的客户" },
  { id: "sh_clientClass_potential", es: "Potencial", ch: "潜在客户" },
  { id: "sh_clientClass_spot", es: "Spot", ch: "仅购买单独体验" },

  { id: "clientClass_unknown", es: "Desconocido", ch: "无特定种类" },
  { id: "clientClass_agency", es: "Cliente de Agencia", ch: "旅行社" },
  { id: "clientClass_curious", es: "Curioseando / interesado, pero no ahora", ch: "出于兴趣关注的客户" },
  { id: "clientClass_potential", es: "Cliente potencial", ch: "潜在客户" },
  { id: "clientClass_spot", es: "Cliente spot", ch: "仅购买单独体验" },

  { id: "hashtags_desconocido", es: "Desconocido", ch: "XXX" },
  { id: "hashtags_high", es: "Hashtags más buscados", ch: "XXX" },
  { id: "hashtags_minor", es: "Hashtags menos buscados", ch: "XXX" },
  { id: "hashtags_fake", es: "Hashtags fakes", ch: "XXX" },

  { es: "Evaluación subjetiva", ch: "主观评价" },
  { es: "Rellene los campos obligatorios (*)", ch: "必须填写标星项目(*)" },

  { id: "clientClass_spot", es: "Cliente spot", ch: "仅购买单独体验" },

  { id: "clientChannel_unknown", es: "Desconocido", ch: "无特定种类" },
  { id: "clientChannel_baidu", es: "Baidu", ch: "百度" },
  { id: "clientChannel_wechat_any", es: "WeChat cualquiera", ch: "来自微信任一方式" },
  { id: "clientChannel_wechat_search", es: "WeChat buscador", ch: "来自微信搜索" },
  { id: "clientChannel_wechat_post", es: "WeChat post", ch: "来自微信公众号" },
  { id: "clientChannel_friends", es: "Recomendación de un amigo", ch: "朋友推荐" },

  { es: "Fecha", ch: "日期" },
  { es: "Hora", ch: "时间" },
  { es: "Dirección", ch: "地址" },
  { es: "Vouchers", ch: "预定涵" },
  { es: "Falta por añadir la descripcion.", ch: "简介暂缺" },
  { es: "Falta por añadir alguna imagen.", ch: "图像暂缺" },
  { es: " Ir a la actividad", ch: "前往改活动" },
  { es: "Buscar cliente", ch: "搜索客户" },
  { es: "Buscar por nombre", ch: "按姓名搜索" },

  { es: "Incluir hotel último dia", ch: "包含最后一天的酒店" },
  { es: "Incluir textos en español", ch: "包括西语内容" },

  { id: "delete_payment", es: '¿Seguro que desea borrar el pago "$$?"', ch: "确定要删除该项支付款项\"$$\"？" },
  { id: "no_payments", es: 'No hay pagos de este viaje', ch: "改行程暂未有任何付款" },
  { id: "sh_Otros"             , es: "Otros"         , ch: "其他" } ,
  { id: "delete_supplier", es: '¿Seguro que desea borrar el proveedor "$$"?', ch: "确定要删除该供应商\"$$\"？" },
  { es: "Descripción *vacía*", ch: "简介状态为空" },
  { es: "Descripción larga *vacía*", ch: "长简介部分状态为空" },
  { es: "falta la fecha de inicio", ch: "缺少开始日期" },
  { es: "Pagos", ch: "付款" },
  { id: "clientClass_viajeros", es: "Viajeros (curiosos y potenciales)", ch: "客户（好奇及潜在状态）" },
  { id: "clientClass_all", es: "Sin filtro", ch: "全部 " },
  { id: "hashtags_all", es: "Todos los hastags", ch: "XXX " },
  { es: "Recuerda también introducir la fianza en la lista de pagos del cliente", ch: "记得将定金支付添加入客户付款列表中" },
  { es: "La ruta de este cliente cuesta $$€ pero sólo tiene pagado hasta $$€. Recuerda introducir sus pagos", ch: "该客户路线报价总额为$$€实际只支付了$$€。请记得将他的其他支付部分补充完整" },
  { es: "Pueden faltar pagos", ch: "暂未支付完全款" },
  { es: "Estado cliente", ch: "客户状态" },
  { es: "Parece que el cliente ha pagado todo, ¿actualizar el estado del cliente?", ch: "客户已支付完全款，立即更新客户状态？" },
  { es: "No cambiar", ch: "无变更项目" },
  { es: "Parece que el cliente ha pagado parte del viaje, ¿Cambiar el estado del cliente?", ch: "客户已支付了部分款项，立即更新客户状态？" },
  { id: "1a Propuesta", es: "1ª Propuesta", ch: "1.已发送路线" },
  { id: "sh_1a Propuesta", es: "1ª Propuesta", ch: "1.已发送路线" },
  { id: "Negociando", es: "Negociando", ch: "进行商议阶段" },
  { id: "sh_Negociando", es: "Negociando", ch: "进行商议阶段" },
  { es: "¿Ya tiene visado?", ch: "是否已有签证？" },
  { es: "Tiene visado", ch: "已有签证" },

  { id: "name", es: "Nombre", ch: "姓名" },
  { id: "numRepetitions", es: "Número de repeticiones", ch: "出行人数" },
  { id: "repetitionDates", es: "Fechas", ch: "日期" },
  { id: "date", es: "Fecha", ch: "日期" },
  { id: "time", es: "Horario", ch: "时间" },
  { id: "Reservas", ch: "预定", },
  { id: "Descargar CSV", ch: "下载行程单", },
  { id: "Número de factura", ch: "发票人数", },
  { id: "Fecha de factura", ch: "发票时间", },
  { id: "Estado reserva", ch: "预定状态", },
  { id: "Estimado", ch: "大致相同", },
  { id: "Final", ch: "完结", },
  { id: "Error (ver arriba)", ch: "错误（返回上层查看）", },
  { id: "Eliminar reserva (ya no sirve)", ch: "删除该项预定（已不可使用）", },
  { id: "OK, la reserva sigue valiendo, o yo lo corrijo", ch: "该项预定已随同路线调整做了相应调整", },
  { id: "Coste Chinespain", ch: "ChineSpain成本", },
  { id: "Total cobrado (recibido)", ch: "总收款（全部收款额）", },
  { id: "Beneficio", ch: "利润", },
  { id: "Comisión Booking", ch: "Booking返点", },
  { id: "Beneficio total", ch: "总利润", },
  { id: "Porcentaje", ch: "百分比", },
  { es: "Imágen #1", ch: "图像1" },
  { es: "Imágen #2", ch: "图像2" },
  { id: "voucher_description", es: "🇨🇳 Descripción Voucher", ch: "🇨🇳 预定涵简介" },
  { es: "Ficheros Voucher", ch: "预定涵" },
  { es: "Terminar tareas", ch: "任务完成" },
  { es: "Parece que el cliente ha sido cerrado, ¿deseas terminar todas sus tareas?", ch: "客户已完成旅行，是否将所有有关该客户的任务设置为完成状态？" },
  { es: "Teléfono", ch: "电话" },
  { es: "Actividad", ch: "活动" },
  { es: " la actividad ", ch: "活动" },

  { es: "Compras", ch: "购物" },
  { es: "Ventas", ch: "销售" },
  { es: "Ver todas las ciudades", ch: "查看所有城市" },
  { es: "Actividades con dirección introducida", ch: "活动与输入的地址" },
  { es: "Actividades con dirección calculada automáticamente", ch: "计算机计算地址的活动" },
  { es: "Error al cargar la ruta. Intentelo de nuevo", ch: "加载路线时出错请重试" },
  { es: "Viajes y actividades", ch: "旅行和活动" },
  { es: "No se pudo geocodificar al menos a una de las ubicaciones especificadas", ch: "无法对至少一个指定位置进行地理编码" },
  { es: "¡Vas demasiado rápido! Por el ratón de nuevo sobre el día.", ch: "你的速度太快，那天再次点击鼠标" },
  { es: "No fue posible hallar una ruta $$ entre $$ y $$. Pruebe a cambiar el modo de transporte.", ch: "($$)$$和$$之间没有找到路线。 尝试改变传输模式" },
  { es: "No se pudo obtener automaticamente la direccion de $$, introducela. ", ch: "无法自动获取$$地址, " },
  { id: "address_link", es: 'aquí', ch: "请在此输入" },
  { es: 'en transporte público', ch: "公共交通" },
  { es: 'andando', ch: "步行" },
  { es: 'conduciendo', ch: "主动" },
  { es: 'en coche con guia', ch: "带导游的汽车" },


  { id: 'useCustomFee', es: 'usar gasto de gestion modificado', ch: "使用修改的管理费用" },
  { id: 'customFee', es: 'gasto de gestion modificado', ch: "修改的管理费用" },
  { id: 'useCustomPrice', es: 'usar precio modificado', ch: "使用修改过的价格" },
  { id: 'customPrice', es: 'precio modificado', ch: "修改的价格" },
  { id: 'general', es: 'Precio general', ch: "正常价格" },
  { id: 'expense', es: " el gasto ", ch: "费用" },
  { es: " el gasto ", ch: "费用" },
  { es: " el gasto general ", ch: "一般费用" },
  { es: " el comentario ", ch: "备注事项" },
  { es: " el pago ", ch: "付款" },
  { id: 'price', es: 'el precio', ch: "价格" },
  { id: 'title', es: 'Título', ch: "名称" },
  { id: 'transport', es: 'transporte', ch: "交通方式" },
  { es: ' el transporte ', ch: "交通方式" },
  { id: 'recommendedTransportation', es: 'el transporte recomendado', ch: "推荐的交通方式" },
  { id: "shouldGoToHotelFirst", es: "Llevar maletas al hotel", ch: "带行李到酒店", },

  { id: 'NULL', es: 'No indicar', ch: "没有说明" },
  { id: 'PUBLIC_TPT', es: 'Transporte público', ch: "公共交通" },
  { id: 'WALKING', es: 'Andando', ch: "步行" },
  { id: 'DRIVE', es: 'Conduciendo', ch: "自驾" },
  { id: 'CABIFY', es: 'Te ponemos un Cabify', ch: "我们给您在cabify平台订车" },
  { id: 'GUIDE', es: 'El guía te lleva', ch: "携带指南" },
  { id: 'TAXI', es: 'Pide un taxi', ch: "订出租车" },
  { id: 'OTHER', es: 'Otro', ch: "其他" },

  { id: 'RT_NULL', es: 'No indicar', ch: "没有说明" },
  { id: 'RT_PUBLIC_TPT', es: 'Transporte público', ch: "公共交通" },
  { id: 'RT_WALKING', es: 'Andando', ch: "步行" },
  { id: 'RT_DRIVE', es: 'Conduciendo', ch: "自驾" },
  { id: 'RT_CABIFY', es: 'Te ponemos un Cabify', ch: "我们给您在cabify平台订车" },
  { id: 'RT_GUIDE', es: 'El guía te lleva', ch: "携带指南" },
  { id: 'RT_TAXI', es: 'Pide un taxi', ch: "订出租车" },
  { id: 'RT_OTHER', es: 'Otro', ch: "其他" },

  { id: 'trips', es: 'el viaje', ch: "这次旅行" },
  { id: 'routes', es: 'la ruta', ch: "路线" },
  { es: 'Creado', ch: "创建" },
  { es: 'Modificado', ch: " 修改" },
  { es: 'Canal de entrada', ch: "输入通道" },
  { es: 'Estrellas', ch: "明星" },
  { es: "$$ cambió a $$", ch: "更改$$为$$" },
  { es: " Se ha añadido ", ch: "添加了" },
  { es: "Se ha añadido $$ con:", ch: "添加了$$" },
  { es: " Se ha borrado ", ch: "删除了" },
  { es: " Se ha movido ", ch: "移动了" },
  { es: " Se ha modificado ", ch: " 更改了" },
  { es: " se ha modificado", ch: " 更改了" },
  { es: " el día ", ch: "天" },
  { es: " al día $$", ch: "到$$天止" },
  { es: " del día $$", ch: "从$$天起" },
  { es: " en el día $$:", ch: "在第$$天:" },
  { es: "a gastos generales", ch: "算入开销" },
  { es: "de gastos generales", ch: "从开  销里支出" },
  { es: "activado", ch: "已激活" },
  { es: "desactivado", ch: "已失效" },
  { es: "Hoy", ch: "今天" },
  { es: "Ayer", ch: "昨天" },
  { es: "[El] dddd [pasado] (DD/MM/YYYY)", ch: "[上星期]dddd (DD/MM/YYYY)" },
  { es: " se ha modificado de $$ a $$", ch: "把$$更改为$$" },
  { es: "Viaje de $$", ch: "$$的旅行" },

  {
    id: "activity_price_changed",
    es: "El precio de esta actividad ha cambiado desde que se añadió a esta ruta:",
    ch: "本体验活动的价格现已重新调价"
  },

  { id: "prop_agenda",              es: "Ruta" },
  { id: "prop_expenses",            es: "Gastos generales" },
  { id: "prop_realName",            es: "Nombre (pinyin)" },
  { id: "prop_wechat",              es: "WeChat ID" },
  { id: "prop_email",               es: "Email" },
  { id: "prop_origin",              es: "Origen" },
  { id: "prop_adults",              es: "Adultos" },
  { id: "prop_startDate",           es: "Inicio" },
  { id: "prop_endDate",             es: "Fin" },
  { id: "prop_hasVisa",             es: "Tiene visado" },
  { id: "prop_clientClass",         es: "Tipo de cliente", },
  { id: "prop_clientChannel",       es: "Canal de entrada" },
  { id: "prop_stars",               es: "Evaluación subjetiva" },
  { id: "prop_note",                es: "Notas contrato" },
  { id: "prop_returnDescription",   es: "Descripción retorno" },
  { id: "prop_comment",             es: "Comentario breve" },
  { id: "prop_useForcedPrice",      es: "Precio a mano" },
  { id: "prop_forcedPriceEur",      es: "Precio en euros" },
  { id: "prop_forcedPriceYuan",     es: "Precio en yuanes" },
  { id: "prop_notes",               es: "Comentarios" },
  { id: "prop_payments",            es: "Pagos" },
  { id: "prop_finalPrice",          es: "Precio final" },
  { id: "prop_baseImponible",       es: "Base imponible" },
  { id: "prop_supplier",            es: "Proveedor" },
  { id: "prop_status",              es: "Estado" },
  { id: "prop_receipt",             es: "Factura" },
  { id: "prop_receiptDate",         es: "Fecha factura" },
  { id: "prop_cost",                es: "Coste" },
  { id: "prop_address",             es: "Dirección" },
  { id: "prop_files",               es: "Ficheros" },
  { id: "prop_description",         es: "Descripción" },
  { id: "prop_longDescription",     es: "Descripción larga" },
  { id: "prop_longdescription",     es: "Descripción larga" },
  { id: "prop_duration",            es: "Duración" },
  { id: "prop_city",                es: "Ciudad" },
  { id: "prop_preciseLocation",     es: "Localiación exacta" },
  { id: "prop_clientNote",          es: "Nota para el cliente" },
  { id: "prop_tags",                es: "Etiquetas" },

  { id: "prop_name", es: "Apodo", },
  { id: "prop_kids", es: "Niños", },
  { id: "prop_date", es: "Fecha", },
  { id: "prop_title", es: "Título", },
  { id: "prop_price", es: "Precio", },

  { id: "logcol_trips", es: "Viaje de", },
  { id: "logcol_activities", es: "Actividad", },
  { id: "logcol_suppliers", es: "Proveedor", },
  { id: "logcol_cities", es: "Ciudad", },
  { id: "logcol_products", es: "Producto (ZSX)", },
  { id: "logcol_activities", es: "Actividad", },

  { es: "No se sabe disponibilidad", ch: "有待确认准确时间" },
]

export default data
